import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { RouterProvider } from 'react-router';

import { AuthProvider } from '@/auth/AuthProvider';
import { StudentViewProvider } from '@/features/studentView/StudentViewProvider';
import { PwaShell } from '@/pwa/PwaShell';
import { router } from '@/routes/index';
import { ThemeProvider } from '@/theme/ThemeProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

export function AppProviders() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <StudentViewProvider>
          <ThemeProvider>
            <TooltipPrimitive.Provider delayDuration={200}>
              <PwaShell>
                <RouterProvider router={router} />
              </PwaShell>
            </TooltipPrimitive.Provider>
          </ThemeProvider>
        </StudentViewProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
